import * as utils from 'global/common/globalUtils';

function updateQty({ articleNumber, qty }) {
	const inputs = document.querySelectorAll(
		`input[data-quantity="true"][data-article-number="${articleNumber}"]:not([data-no-sync])`,
	);
	inputs.forEach(input => {
		input.value = qty;
	});
}

function syncQtysToPublishedQty({ articleNumber, qty, sourceId }) {
	document
		.querySelectorAll(
			`input[data-quantity][data-article-number="${articleNumber}"]:not([data-no-sync])`,
		)
		.forEach(input => {
			const inputId = input.dataset.syncId || utils.generateSyncId(input);
			if (inputId !== sourceId && input.value !== qty) {
				input.value = qty;
			}
		});
}

export default function quantityInput() {
	const isQuantityInput = e =>
		e.target.tagName === 'INPUT' && e.target.hasAttribute('data-quantity');

	const handleInput = e => isQuantityInput(e) && handleQuantityInput(e.target);
	const handleBlur = e => isQuantityInput(e) && handleQuantityBlur(e.target);

	document.addEventListener('input', handleInput, false);
	document.addEventListener('blur', handleBlur, true);
	subscribeEvents();

	function subscribeEvents() {
		window.od.events.subscribe(
			'productPriceTable_RowSelected',
			updateQty.bind(this),
		);

		window.od.events.subscribe(
			'quantityInput_QtyChanged',
			syncQtysToPublishedQty.bind(this),
		);

		window.od.events.subscribe(
			'addToCart_QtyReset',
			syncQtysToPublishedQty.bind(this),
		);
	}

	function handleQuantityInput(input) {
		input.value = input.value.replace(/\D+/g, '');

		window.od.events.publish('quantityInput_QtyChanged', {
			articleNumber: input.getAttribute('data-article-number'),
			qty: input.value,
			sourceId: input.dataset.syncId || utils.generateSyncId(input),
		});
	}

	function handleQuantityBlur(input) {
		const min = parseInt(input.min, 10);
		const max = parseInt(input.max, 10);
		let value = parseInt(input.value, 10);

		if (isNaN(value)) {
			value = input.getAttribute('value') || 0;
			input.value = value;

			window.od.events.publish('quantityInput_InvalidCharactersRemoved', {
				articleNumber: input.getAttribute('data-article-number'),
				qty: input.value,
			});
		}

		let setValue = value;
		setValue = value < min ? min : setValue;
		setValue = value > max ? max : setValue;

		if (setValue !== value) {
			input.value = setValue;

			window.od.events.publish('quantityInput_QtyChanged', {
				articleNumber: input.getAttribute('data-article-number'),
				qty: input.value,
			});
		}
	}
}

/* eslint-disable-next-line no-underscore-dangle */
export const __testExports__ = { updateQty, syncQtysToPublishedQty };
